import type { APIMessage } from '@alternativamais/chat-core';
import { createContext, useContext } from 'react';

import type { Posicao } from '../../../componentes/Flutuante';
import type { EmojiEscolhido } from '../SeletorEmoji';

/** O que as mensagens da lista pedem ao canal (responder, editar, pular…). */
export type AcoesDoCanal = {
  canalId: string;
  guildId: string | null;
  responder(mensagem: APIMessage): void;
  editandoId: string | null;
  editar(id: string | null): void;
  irPara(id: string): void;
  destacadaId: string | null;
  abrirEmoji(
    ancora: Posicao,
    aoEscolher: (emoji: EmojiEscolhido) => void,
  ): void;
  apagar(mensagem: APIMessage, semConfirmar?: boolean): void;
  /** Criar thread a partir da mensagem (só no canal: thread não tem thread). */
  criarThread?: (mensagem: APIMessage) => void;
  /** Mencionar alguém no compositor (menu do membro). */
  mencionar(texto: string): void;
};

export const ContextoCanal = createContext<AcoesDoCanal | null>(null);

export function useCanal(): AcoesDoCanal {
  const contexto = useContext(ContextoCanal);
  if (!contexto) throw new Error('Fora do canal.');
  return contexto;
}
